module.exports = __webpack_public_path__ + "img/man-body-upper-back.08fc2da6.png";